import * as apiSW from 'api/identityProvider/GetIdentityProviderStartingWithV1';
import * as apiPostSearch from 'api/identityProvider/PostIdentityProviderSearchV1';
import IdentityProvider from 'classes/StandingData/IdentityProvider/Search/IdentityProvider';
import { ISelectItem } from 'interfaces/ISelectItem';

export default class IdentityProviderList {
	public all: IdentityProvider[] = [];
	public filtered: ISelectItem[] = [];
	public totalCount: number = 0;

	public async search(searchTerm: string, showOnlyDeleted: boolean): Promise<void> {
		const identityProviders = await apiSW.callApi(searchTerm, showOnlyDeleted);
		identityProviders.hasValue() && this.mapFromApiSW(identityProviders.get());
	}

	public async callApi(input: apiPostSearch.Request) {
		return await apiPostSearch.callApi(input);
	}

	public mapFromApi(input: apiPostSearch.ResponseData): void {
		this.totalCount = input.totalCount;
		this.all = [];
		for (const ip of input.data) {
			const identityProvider: IdentityProvider = new IdentityProvider(ip);
			this.all.push(identityProvider);
		}
	}

	public mapFromApiSW(input: apiSW.ResponseIdentityProvider[]): void {
		this.filtered = [];
		for (const i of input) {
			this.filtered.push({
				id: i.id,
				name: i.description,
			});
		}
	}
}
